import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@15.5.2_@babel+core@7.28.3_babel-plugin-react-compiler@19.1.0-rc.2_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/animated-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedText"] */ "/opt/build/repo/src/components/animated-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTop"] */ "/opt/build/repo/src/components/back-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuyMeACoffeeButton"] */ "/opt/build/repo/src/components/buymeacoffee-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/opt/build/repo/src/components/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GumroadButton"] */ "/opt/build/repo/src/components/gumroad-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MagneticButton"] */ "/opt/build/repo/src/components/magnetic-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/opt/build/repo/src/components/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioShowcase"] */ "/opt/build/repo/src/components/portfolio-showcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProgress"] */ "/opt/build/repo/src/components/scroll-progress.tsx");
